import { Component, input } from '@angular/core';
import { WcgChipType } from '@wcg/frontend-framework';

export enum ChipLabelStatus {
  pending = 'Pending',
  approved = 'Approved',
  closed = 'Closed',
  disapproved = 'Disapproved',
  suspended = 'Suspended',
}

@Component({
    selector: 'chip-status',
    templateUrl: './chip-status.component.html',
    styleUrls: ['./chip-status.component.scss'],
    standalone: false
})
export class ChipStatusComponent {
  ChipLabelStatus = ChipLabelStatus;
  WcgChipType = WcgChipType;
  readonly label_status = input.required<ChipLabelStatus | 'Pending' | 'Approved' | 'Closed' | 'Disapproved' | 'Suspended'>();
  readonly expired_date = input('');
}
